import { render, staticRenderFns } from "./matchingLibrary.vue?vue&type=template&id=1ed30425&scoped=true"
import script from "./matchingLibrary.vue?vue&type=script&lang=js"
export * from "./matchingLibrary.vue?vue&type=script&lang=js"
import style0 from "./matchingLibrary.vue?vue&type=style&index=0&id=1ed30425&prod&lang=stylus"
import style1 from "./matchingLibrary.vue?vue&type=style&index=1&id=1ed30425&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed30425",
  null
  
)

export default component.exports